import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IDesignation } from "../designationModel";

export const getAllDesignation = createAsyncThunk(
  "Designation/FindAllDesignation",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Designation/FindAllDesignation`,
        {}
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Designation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createDesignation = createAsyncThunk(
  "Designation/InsertDesignation",
  async (DesignationData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Designation/InsertDesignation`,
        DesignationData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Designation:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateDesignation = createAsyncThunk(
  "Designation/UpdateDesignation",
  async (DesignationData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Designation/UpdateDesignation`,
        DesignationData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Designation :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteDesignation = createAsyncThunk(
  "Designation/DeleteDesignation",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Designation/DeleteDesignation`,
        { ID: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Designation :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDesignationByID = createAsyncThunk(
  "Designation/FindByIDDesignation",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Designation/FindByIDDesignation`,
        { ID: ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Description: result.Description,
        Position: result.Position,
        IsActive: result.IsActive ? 1 : 2,
      } as IDesignation;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Designation :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveDesignation = createAsyncThunk(
  "Designation/FindAllActiveDesignation",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Designation/FindAllActiveDesignation`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Designationes:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveDesignation = createAsyncThunk(
  "Designation/ActiveInActiveDesignation",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Designation/ActiveInActiveDesignation`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Designation :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
